import { Container, Stack, Text, Title } from "@mantine/core";
import { TaskForm } from "../components/TaskForm";

export function HomePage() {
  return (
    <Container size="md">
      <Stack gap="lg">
        <Stack gap={4}>
          <Title order={1}>🧩 MetaTRIZ</Title>
          <Text c="dimmed">
            Мультиагентная ТРИЗ-система для бизнес и софтверных задач. Решает задачи через
            канон Альтшуллера: 40 приёмов разрешения противоречий, 39 параметров, матрица
            39×39 с ~1248 каноническими ячейками.
          </Text>
        </Stack>
        <TaskForm />
      </Stack>
    </Container>
  );
}
